import './app.scss';

import Container from '../lib/services/Container';
import App from './App';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import * as VueGoogleMaps from 'gmap-vue';
import VueSignaturePad from 'vue-signature-pad';

import components from './app/components';
import plugins from './app/plugins';
import VueFactory from '@services/VueFactory';
import ModeSwitcher from '@csp-app/lib/ModeSwitcher';

const container = Container.getInstance();
const vueFactory = new VueFactory();
const appVersion = document.getElementById('app').getAttribute('data-app-version');

const i18n = vueFactory.initializeI18n();
container.getTranslator().setVueI18n(i18n);

vueFactory.useRouter((new ModeSwitcher()).getRoutes());

container.getErrorHandler().attachErrorLoggerToWindow(window);

Vue.config.errorHandler = function(err, vm, info) {
    const errorMessage = `Error: ${err.toString()}, Info: ${info}`;
    // noinspection JSIgnoredPromiseFromCall
    container.getErrorHandler().logError(errorMessage);
    console.error(errorMessage);
}

i18n.missing = (locale, key) => {
    container.getTranslationRepository().reportMissing(key);
};

plugins.forEach((plugin) => {
    Vue.use(plugin);
});

for (let componentsKey in components) {
    Vue.component(componentsKey, components[componentsKey]);
}

vueFactory.usePlugin(
    VueGoogleMaps,
    {
        load: {
            key: 'AIzaSyDb3STd2hlZKqCODtzXI5BEB9hver1wEYw',
            libraries: 'places, geometry', // Necessary for places input
        },
        installComponents: true,
    }
);
vueFactory.usePlugin(VueCompositionAPI);

vueFactory.usePlugin(VueSignaturePad);

Vue.mixin({
    methods: {
        getOptionForCheckbox(label) {
            return [
                {value: 1, text: this.$t(label)},
            ]
        },
    },
});

container.getErrorHandler().initialize();

vueFactory.setData({
    loadingState: container.getLoadingState().state,
    signState: container.getSignRepository().state,
    multiselectOptionHeight: 48,
    useLegacyPdfViewer: null,
    appVersion: appVersion,
});

const app = vueFactory.createVue(App);

container.getLoadingState().initialize();
container.getReloadPreventer().initialize();

container.getTranslationRepository().loadTranslation().then((result) => {
    const attributes = result.data.attributes;
    i18n.setLocaleMessage(attributes.locale, attributes.messages);
    i18n.locale = attributes.locale;
    container.getEventBus().emit('translations-loaded');
});

app.$mount('#app');
